import { useEffect, useState } from "react";
import { api } from "./api";

export function useDir(includeInactive = false) {
  const [dir, setDir] = useState(null);
  const load = () => api.get(`/directory${includeInactive ? "?include_inactive=true" : ""}`).then((r) => setDir(r.data));
  useEffect(() => { load(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { dir, reload: load };
}
